import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import * as roleService from "../../services/role.services";
import { Placeholder } from "rsuite";
import { capitalizeFirstLetter, formateDateWithMonth } from "../../../../utils/commonfunction";

const RoleView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [loader, setLoader] = useState(true);
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("label_sub_admin"), url: "/admin/staff/list/1" },
    { title: t("label_role"), url: "/admin/role/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    if (params.id) {
      roleService
        .Details(params.id)
        .then((response) => {
          if (response?.data) setShowDefault(response.data);
        })
        .catch(() => setShowDefault({}))
        .finally(() => setLoader(false));
    } else setLoader(false);
  }, [params.id]);

  const permissions = showdefault?.permissions || showdefault?.permissionIDs || [];
  const permList = Array.isArray(permissions) ? permissions : [];
  const permissionLabels = permList.map((p) =>
    typeof p === "object" ? (p.title || p.short_slug || p.shortSlug || p._id || "—") : String(p)
  );

  const hasData = showdefault && Object.keys(showdefault).length > 0;

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t("btn_view")} {t("label_role")}
                </h6>
              </div>
              {loader ? (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active rows={7} />
              ) : hasData ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("label_title")}</th>
                          <td>{capitalizeFirstLetter(showdefault?.title) ?? "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_permissions")}</th>
                          <td>
                            {permissionLabels.length === 0 ? (
                              "N/A"
                            ) : (
                              <ul className="mb-0 pl-3">
                                {permissionLabels.map((name, idx) => (
                                  <li key={idx}>{name}</li>
                                ))}
                              </ul>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault?.createdAt ? formateDateWithMonth(showdefault.createdAt) : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_modified_date")}</th>
                          <td>
                            {showdefault?.updatedAt ? formateDateWithMonth(showdefault.updatedAt) : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active rows={7} />
              )}
            </div>
            <div className="mt-5 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() => navigate("/admin/role/list/1")}
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleView;
